import { compose } from 'recompose';
import { Typography, withStyles } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import styles from './styles';
import classNames from 'classnames';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { IconService } from 'services/icon/iconService';
import {
  getTemplateStopTypeString,
  TemplateStopType,
} from 'services/enums/TemplateStopType';

function TemplateStopIconLegend(props) {
  const { classes, className, t } = props;

  const rootClassName = classNames(classes.root, className);

  return (
    <Fragment>
      <Typography
        className={rootClassName}
        variant="body1"
      >
        <Fragment>
          {
            <span
              className={classes.materialIcon}
              dangerouslySetInnerHTML={{
                __html: IconService.getChestMarkerSvgTemplate(
                  '#ffffff',
                  '',
                  '#000000'
                ),
              }}
            />
          }
          {t(getTemplateStopTypeString(TemplateStopType.Delivery))}&nbsp;
          {
            <span
              className={classes.materialIcon}
              dangerouslySetInnerHTML={{
                __html: IconService.getShopMarkerSvgTemplate(
                  '#ffffff',
                  '',
                  '#000000'
                ),
              }}
            />
          }
          {t(getTemplateStopTypeString(TemplateStopType.Pickup))}&nbsp;
        </Fragment>
      </Typography>
    </Fragment>
  );
}

TemplateStopIconLegend.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  withStyles(styles),
  withTranslation()
)(TemplateStopIconLegend);
